import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import { COOKIE_SET_OPTIONS, OPTIMIZELY_USER_ID } from 'config/constants';

const cookies = new Cookies();

const getOptimizelyUserId = (): string => {
  const optimizelyUserId = cookies.get<string | null>(OPTIMIZELY_USER_ID);

  if (!optimizelyUserId) {
    const generatedId = uuidv4();
    cookies.set(OPTIMIZELY_USER_ID, generatedId, COOKIE_SET_OPTIONS);

    return generatedId;
  }

  return optimizelyUserId;
};

export default getOptimizelyUserId;
